import { useEffect, useRef } from 'react';

export const useKey = (key, callback) => {

  const callbackRef = useRef(callback);

  useEffect(() => callbackRef.current = callback);

  useEffect(() => {
    const handler = e => {
      if (e.code === key) {
        callbackRef.current(e);
      }
    };

    document.addEventListener('keydown', handler)
    return () => document.removeEventListener('keydown', handler)
  }, [key])
}